import { render } from "./LinkCollections.vue.js?vue&type=template&id=4bdf8bfb!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LinkCollections.vue?vue&type=template&id=4bdf8bfb"
import script from "./LinkCollections.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LinkCollections.vue?vue&type=script&lang=js"
export * from "./LinkCollections.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LinkCollections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/monetization/LinkCollections.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bdf8bfb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bdf8bfb', __exports__)) {
    api.reload('4bdf8bfb', __exports__)
  }
  
  module.hot.accept("./LinkCollections.vue.js?vue&type=template&id=4bdf8bfb!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LinkCollections.vue?vue&type=template&id=4bdf8bfb", () => {
    api.rerender('4bdf8bfb', render)
  })

}


export default __exports__